const Status = {
  SUCCESS: 0,
  MISSINGGUID: 1,
  EXPIREDTOKEN: 2,
  UNKNOWN: 3,
  NO_INTERNET: 4,
  BAD_REQUEST: 5,
  TURNSTILE: 6,
  SURVEYEXPIRED: 7,
  RESPONSE_LIMIT_REACHED: 8
} as const;

export type StatusValue = (typeof Status)[keyof typeof Status];

export default Status;
